<template>
  <div class="actor_detail">
    <div v-if="!isServerError">
      <section class="no_padding text_center">
        <h2 class="header_underline"><span>鑑定師詳細</span>{{ actorName }}</h2>

        <div v-if="actor != null" class="actor_box">
          <div class="actor_profile">
            <div class="actor_profile_wrap">
              <div class="actor_image">
                <img :src="actorIconURL(actor.token)" v-if="actor.token != null && actor.token.length > 0" :alt="`${actor.name}`" />
                <img src="/assets/img/actor/noimage.png" v-else alt="画像無し" />
              </div>
              <div class="actor_name">
                <span class="actor_evaluation">
                  <img src="/assets/img/actor/evaluation.png" alt="評価数" />
                  <span>{{ actor.evaluation }}件</span>
                </span>
              </div>
            </div>
            <div class="actor_description text_left">
              <p><a href="#" class="btn arrow" @click.prevent="goActorMessage(actor.id)">鑑定依頼をする</a></p>
              <h3 class="actor_career_header"><span>先生の経歴</span></h3>
              <p>{{ actor.career }}</p>
              <h3 class="actor_description_header"><span>先生からのお言葉</span></h3>
              <p>{{ actor.description }}</p>
            </div>
          </div>
          <div class="actor_message_btn">
            <p><a href="#" class="btn arrow" @click.prevent="goActorMessage(actor.id)">鑑定依頼をする</a></p>
          </div>
        </div>
      </section>
      <section class="text_center">
        <p v-if="prevComponent"><a href="#" class="arrow link_main--text" @click.prevent="$router.go(-1)">鑑定師一覧に戻る</a></p>
        <p v-else><router-link :to="{ name: 'Top' }" class="arrow link_main--text">トップページへ戻る</router-link></p>
      </section>
    </div>
    <div v-else>
      <section class="not_found text_center">
        <div>
          <p>鑑定師が見つかりませんでした。</p>
          <p><router-link :to="{ name: 'Top' }" class="arrow link_main--text">トップページへ戻る</router-link></p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { IMAGE_URL } from '@/common/config'
import { GET_ACTOR, GET_ACTOR_BY_SEND_MESSAGE } from '@/store/actor/actions'
import { FETCH_ACTOR } from '@/store/actor/mutations'

export default {
  name: 'ActorDetail',
  data () {
    return {
      id: this.$route.params.id,
      actor: this.$store.getters.actor || null,
      prevComponent: '',
      isServerError: false
    }
  },
  computed: {
    actorName () {
      return (this.actor == null) ? '' : `${this.actor.name}先生`
    }
  },
  methods: {
    getActor () {
      this.$store.dispatch(GET_ACTOR, {
        id: this.id
      })
        .then((data) => {
          this.actor = data
        })
        .catch(error => {
          if (error.errorStatus === 404) {
            this.isServerError = true
          } else {
            this.$router.go(-1)
          }
        })
    },
    goActorMessage (actorId) {
      this.$store.dispatch(GET_ACTOR_BY_SEND_MESSAGE, {
        id: actorId
      })
        .then((data) => {
          if (data.is_point_shortage) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          } else {
            this.$router.pushIsses({ name: 'ActorMessage', params: { id: actorId } })
          }
        })
        .catch(() => {})
    },
    actorIconURL (token) {
      return IMAGE_URL + token
    }
  },
  created () {
    this.getActor()
  },
  beforeRouteEnter (to, from, next) {
    if (!(from.name === 'ActorMessage')) {
      store.commit(FETCH_ACTOR, null)
    }
    next(vm => {
      vm.prevComponent = from.name
    })
  }
}
</script>
